import React from 'react';
import ExternalLanding from "./ExternalLanding";
import useHubSpotUTMQueryParams from "../hooks/useHubSpotUTMQueryParams";
import {externalLinks} from "../requests/external-endpoints";

export const Contact = () => {
  const searchParams = useHubSpotUTMQueryParams();
  const constructedUrl = `${externalLinks.contact}?${searchParams.toString()}`;
  return <ExternalLanding url={constructedUrl} />;
}

export default Contact;
